// import { ImageAttachment, AttachmentBase } from "@/classes/Attachment"
import { v4 as uuidv4 } from "uuid";

const attachmentList = {
  id: 0,
  type: "",
  width: 0,
  height: 0,
  x: 0,
  y: 0,
  img: null,
  file: null,
};

const attachmentPdf = {
  pageNumber: 0,
  attachments: [], // attachmentList
  isAllPage: false,
  index: 0,
};

const state = {
  // pageCurrent: -1,
  // pageAttachments: [], //attachmentList
  allPageAttachments: [], // attachmentPdf
  numPages: 0,
};

const mutations = {
  ADD_ATTACHMENT(state, data) {
    console.log("ADD_ATTACHMENT", data);

    const pageNumber = data.pageNumber;
    const attachment = data.attachment;

    // if (data.isAllPage) {
    //   // add to all pages
    //   for (let i = 1; i <= state.numPages; i++) {
    //     state.allPageAttachments.push({
    //       pageNumber: i,
    //       attachments: [{ ...attachment, id: uuidv4() }],
    //     });
    //   }
    // } else {
    const isFind =
      state.allPageAttachments.filter((f) => {
        // if(f.pageNumber == pageNumber){
        //  return f
        // }
        return f.pageNumber == pageNumber;
      }).length != 0;

    if (isFind) {
      if (data.isAllPage) {
        // add to all pages
        // for (let i = 1; i <= state.numPages; i++) {
        //   state.allPageAttachments.push({
        //     pageNumber: i,
        //     attachments: [{ ...attachment, id: uuidv4() }],
        //   });
        // }
        state.allPageAttachments.map((m) => {
          // if (m.pageNumber == pageNumber) {
          return m.attachments.push({ ...attachment, id: uuidv4() });
          // }
        });
      } else {
        //push
        state.allPageAttachments.map((m) => {
          if (m.pageNumber == pageNumber) {
            return m.attachments.push({ ...attachment, id: uuidv4() });
          }
        });
      }
    } else {
      //add new
      if (data.isAllPage) {
        for (let i = 1; i <= state.numPages; i++) {
          state.allPageAttachments.push({
            pageNumber: i,
            attachments: [{ ...attachment, id: uuidv4() }],
          });
        }
      } else {
        state.allPageAttachments.push({
          pageNumber: pageNumber,
          attachments: [{ ...attachment, id: uuidv4() }],
        });
      }
    }
    console.log("state.allPageAttachments ADD >>>>>", state.allPageAttachments);
    // }
  },
  UPDATE_ATTACHMENT(state, data) {
    console.log("UPDATE_ATTACHMENT", data);
    console.log("numPage >> ", state.numPages);

    const pageNumber = data.pageNumber;
    const attachment = data.attachment;

    if (data.isAllPage) {
      if (state.allPageAttachments.length != state.numPages) {
        // add missing pages
        for (let i = 1; i <= state.numPages; i++) {
          const isExist = state.allPageAttachments.findIndex(
            (f) => f.pageNumber == i
          );
          if (isExist < 0) {
            state.allPageAttachments.push({
              pageNumber: i,
              attachments: [{ ...attachment, id: uuidv4() }],
            });
          }
        }
      } else {
        console.log("update all pages >> ");
        // update all pages
        state.allPageAttachments = state.allPageAttachments.map((m) => {
          m.attachments = m.attachments.map((m2, i) => {
            // if (m2.id == attachment.id) {
            if (i == data.index) {
              return { ...attachment, id: m2.id };
            } else {
              return { ...m2 };
            }
            // } else {
            //   return { ...m2 };
            // }
          });
          return { ...m };
        });
      }
      // state.allPageAttachments = [];
      // for (let i = 1; i <= state.numPages; i++) {
      //   state.allPageAttachments.push({
      //     pageNumber: i,
      //     attachments: [{ ...attachment, id: uuidv4() }],
      //   });
      // }
    } else {
      state.allPageAttachments = state.allPageAttachments.map((m) => {
        if (m.pageNumber == pageNumber) {
          console.log("page >> ", attachment);
          console.log("pageNumber >> ", m.pageNumber);
          m.attachments = m.attachments.map((m2) => {
            if (m2.id == attachment.id) {
              console.log("update attachment >> ", attachment);
              return { ...attachment };
            } else {
              return { ...m2 };
            }
          });
        }

        return { ...m };
      });
    }

    console.log("state.allPageAttachments", state.allPageAttachments);
  },
  DELETE_ATTACHMENT(state, data) {
    const { pageNumber, id } = { ...data };
    state.allPageAttachments.map((m) => {
      if (m.pageNumber == pageNumber) {
        const inxDelete = m.attachments.findIndex((object) => {
          return object.id == id;
        });

        if (inxDelete >= 0) {
          m.attachments.splice(inxDelete, 1);
        }
      }
      return m;
    });
  },
  SET_ALL_PAGE(state, page) {
    // console.log("SET_ALL_PAGE", page, currentState);
    const currentState =
      state.allPageAttachments.filter((f) => {
        return f.pageNumber == page;
      })[0]?.attachments || [];

    if (currentState.length > 0 && currentState != []) {
      state.allPageAttachments = [];
      for (let i = 1; i <= state.numPages; i++) {
        state.allPageAttachments.push({
          pageNumber: i,
          attachments: [...currentState],
        });
      }
    }
  },
  CLEAR_ATTACHMENT(state) {
    state.allPageAttachments = [];
  },
  SET_NUM_PAGES(state, numPages) {
    state.numPages = numPages;
  },
};

const getters = {
  pageAttachments: (state) => (pageNumber) => {
    const result =
      state.allPageAttachments.filter((f) => {
        return f.pageNumber == pageNumber;
      }) || [];

    console.log("pageAttachments", pageNumber, result);

    if (result.length != 0) {
      return result[0].attachments || [];
    }

    return [];
  },
};

const actions = {};

export default {
  state,
  mutations,
  getters,
  // actions
};
